export const NEWS_HEADER_IMAGE = 'https://placehold.co/900x600';
export const TITLE_ON_AIR = 'RADIO TITLE GOES HERE (15H - 16H51)';
export const NEXT_TITLE_ON_AIR = 'NEXT TITLE (17 - 18:48)';
